import Controller from '@ember/controller';
import { action, set } from '@ember/object';
import { alias } from '@ember/object/computed';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';

import { getConsentFromStorage } from '@repo/account-management-kit/utils';
import { Spinner } from '@repo/design-system-kit';
import { VideoAnimations } from '@repo/domain-kit/onboarding';
import { dropTask } from 'ember-concurrency';
import window from 'ember-window-mock';

import ENV from 'register-partners-js/config/environment';

import styles from './styles.module.css';

export default class WelcomePasswordCreationController extends Controller {
  spinner = Spinner;
  videoAnimations = VideoAnimations;
  @service session;
  @service segment;
  @service store;
  @service intl;
  @service marketingConsent;
  @service router;

  @tracked wasPasswordStrengthValid = false;
  @tracked hasSubmitted = false;

  @alias('model.user') user;
  @alias('model.redirection') redirection;

  @alias('user.validations.attrs.password.isValid') isPasswordStrengthValid;

  get passwordIntroSrc() {
    return `${ENV.videoPath}/register-password-intro.mp4`;
  }

  get passwordFallbackSrc() {
    return '/illustrations/animations/register-password-fallback.png';
  }

  @action
  handleGoBack() {
    window.history.back();
  }

  submitTask = dropTask(async () => {
    this.hasSubmitted = true;
    let { model, validations } = await this.user.validate({ on: ['password'] });

    if (validations.isValid) {
      let user = await this.user.save();
      let credentials = user.getProperties('email', 'password');
      await this.session.authenticate('authenticator:custom', credentials);

      if (user.email) {
        let consent = getConsentFromStorage();
        await this.marketingConsent.submitMarketingConsent(user.email, consent);
      }

      this.segment.track('onboarding_partner_password_confirmed');
      this.segment.track('onboarding_partner_credentials_succeeded');
    } else {
      model.set('didValidate', true);
    }
  });

  @action
  updatePassword(newValue) {
    set(this.model.user, 'password', newValue);

    this.wasPasswordStrengthValid = this.isPasswordStrengthValid;
  }
  styles = styles;
}
